import { useState } from "react";
import { SearchState } from "../../types";
import { Overlay2 } from "@blueprintjs/core";
import { CloseIcon } from "@chakra-ui/icons";
import { storeListIcon, themeColours } from "../../resources";
import "./ItemConfigOverlay.css";
import { GoArrowUpRight } from "react-icons/go";
import { getProductVolumeString } from "../../utils";

export function ItemConfigOverlay({
  config,
}: {
  config: SearchState & {
    title: string;
  };
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosed, setIsClosed] = useState(true);

  function handleOpenClick() {
    setIsOpen(true);
    setIsClosed(false);
  }

  function handleCloseClick() {
    setIsOpen(false);
    setIsClosed(true);
  }
  const isSpecific = config.barcode != null;
  return (
    <>
      <span onClick={handleOpenClick}>
        <GoArrowUpRight />
      </span>
      {isOpen && (
        <Overlay2 isOpen={isOpen} className={isClosed ? "" : "modalOverlay"} hasBackdrop={true}>
          <div className="modalContainer">
            <div className="itemConfigContent">
              <span className="closeModalSpan">
                <CloseIcon onClick={handleCloseClick} color={themeColours.secondary} boxSize={3} />
              </span>
              <h1 className="itemConfigName">{isSpecific ? "Specific item" : "Categorised Item"}</h1>
              <div className="itemConfigInfo">
                {isSpecific ? (
                  <h6>
                    <strong className="extraBold">Barcode</strong>: {config.barcode}
                  </h6>
                ) : (
                  <>
                    <h6>
                      <strong className="extraBold">Category</strong>: {config.category}
                    </h6>
                    <h6>
                      <strong className="extraBold">Sub-categories:</strong>{" "}
                      {Object.keys(config.subCategories).map((subcat, i) => {
                        if (i < Object.keys(config.subCategories).length - 1) return subcat + "| ";
                        else return subcat;
                      })}
                    </h6>
                    <h6>
                      <strong className="extraBold">Brands</strong>:{" "}
                      {Object.keys(config.brands).map((brand, i) => {
                        if (i < Object.keys(config.brands).length - 1) return brand + "| ";
                        else return brand
                      })}
                    </h6>
                    <h6>
                      <strong className="extraBold">Volume</strong>: {getProductVolumeString(config)}
                    </h6>
                  </>
                )}
                <span className="itemConfigStores">
                  <p style={{ marginRight: 8 }}>
                    <strong className="extraBold">Stores</strong>:{" "}
                  </p>
                  {Object.keys(config.stores).map((store) => (
                    <img src={storeListIcon[store]} alt="store"></img>
                  ))}
                </span>
              </div>
            </div>
          </div>
        </Overlay2>
      )}
    </>
  );
}
